export const highlightsConstants = {
    //get all highlights
    HIGHLIGHTS_REQUEST: 'HIGHLIGHTS_GET_REQUEST',
    HIGHLIGHTS_SUCCESS: 'HIGHLIGHTS_GET_SUCCESS',
    HIGHLIGHTS_FAILURE: 'HIGHLIGHTS_GET_FAILURE',
};